import React from 'react';
import { Image } from 'react-native';
import { StyleSheet } from 'react-native';

export default function AdsPlaceholderImage() {
  return (
    <Image
      source={require('~assets/images/titles/ads-placeholder.svg')}
      style={styles.imageStyle}
      alt="placeholder"
    />
  );
}

const styles = StyleSheet.create({
  imageStyle: {
    height: 70,
    width: 180,
    resizeMode: 'contain',
    flex: 1,
  },
});
